import { toTitleCase } from "common-ui-components/components/utils/string-utils"
import styles from "./Tag.module.css"

const Tag = ({color, children}) => {

  return (
    <div
      className={[styles.container, styles[color?.toLowerCase() || "purple"]].join(" ")}
    >
      {toTitleCase(children)}
    </div>
  )
}

export default Tag
